const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  shop: state => state.user.shop,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userId: state => state.user.userId,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  routerName: state => state.app.routerName,
  language: state => state.app.language,
  dicList: state => state.sysdic.dicList
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js